const NAV_ELEMENT_ID = "anchornav"; //id of the element the anchorlinks will be placed in
const ANCHOR_LINK_CLASSES = ["anchorbar__anchor"]; //additional classes that will be added to the anchorlinks
const ANCHOR_LINK_ACTIVE_CLASS = "activeanchor";
const OFFSET = 25 // Trigger position in % from the top
const DEBUG_MODE = false;

//HTML Structure
/*
    <nav id="anchornav"></nav>
    <a id="eins"></a>
    <section data-anchorname="Eins" data-anchorid="eins">
        <h1>Eins</h1>
    </section>
*/


function initAnchorNav() {
    const sections = document.querySelectorAll("[data-anchorid]");
    const nav = document.getElementById(NAV_ELEMENT_ID);

    //Generate anchorlinks
    sections.forEach(section => {
        const anchorlink = document.createElement("a");
        anchorlink.id = "a-" + section.dataset.anchorid;
        anchorlink.href = "#" + section.dataset.anchorid;
        anchorlink.innerText = section.dataset.anchorname;
        anchorlink.classList.add("auto-anchorlink");
        ANCHOR_LINK_CLASSES.forEach(className => {
            anchorlink.classList.add(className);
        })
        nav.appendChild(anchorlink);
    })

    if (DEBUG_MODE) {
        console.log("Sections:");
        console.log(sections);
    }

    //Validate anchorsections
    let names = [];
    let ids = [];
    sections.forEach(section => {
        const sectionname = section.dataset.anchorname;
        if (names.find(name => { return name == sectionname })) {
            console.error("Duplicate section name: " + sectionname);
        }
        names.push(sectionname);

        const anchorid = section.dataset.anchorid;
        if (ids.find(id => { return id == anchorid })) {
            console.error("Duplicate anchor id: " + anchorid);
        }
        ids.push(anchorid);

        if (!document.getElementById(anchorid)) {
            console.error(`No anchor element found for section ${sectionname} (searching for id="${anchorid}")`);
        }
    })

    const observer = new IntersectionObserver(highlightAnchor, { threshold: 0.01, rootMargin: `0px 0px -${100 - OFFSET - 10}% 0px` });
    sections.forEach(section => {
        observer.observe(section);
    })

    if (DEBUG_MODE) {
        sections.forEach(section => {
            let marker = document.createElement("div");
            marker.innerText = `${section.dataset.anchorname} | anchor id: ${section.dataset.anchorid}`
            marker.style.backgroundColor = "red";
            marker.style.color = "white";
            section.parentElement.insertBefore(marker, section);
        })

/*         let triggerTop = document.createElement("hr");
        triggerTop.style.position = "fixed";
        triggerTop.style.top = OFFSET - 10 + "%";
        triggerTop.style.left = "0px";
        triggerTop.style.width = "100%";
        document.getElementsByTagName("body")[0].appendChild(triggerTop); */
        let triggerBottom = document.createElement("hr");
        triggerBottom.style.position = "fixed";
        triggerBottom.style.bottom = 100 - OFFSET - 10 + "%";
        triggerBottom.style.left = "0px";
        triggerBottom.style.width = "100%";
        document.getElementsByTagName("body")[0].appendChild(triggerBottom);
    }

}

function highlightAnchor(entries) {
    const intersecting = entries.filter(entry => entry.isIntersecting);
    const intersectingAnchor = intersecting.pop();
    if (intersectingAnchor) {
        const anchors = document.getElementsByClassName("auto-anchorlink");
        [...anchors].forEach(anchor => {
            anchor.classList.remove(ANCHOR_LINK_ACTIVE_CLASS);
        });
        document.getElementById("a-" + intersectingAnchor.target.dataset.anchorid).classList.add(ANCHOR_LINK_ACTIVE_CLASS);
    }
}

$(document).ready(initAnchorNav);